import React, { useState, useEffect } from "react";
import { FaEdit, FaTrashAlt, FaComment } from "react-icons/fa";
import EditNewsModal from "./EditNewsModal";
import "react-quill/dist/quill.snow.css";
import {
  getCommentsByNews,
  createComment,
  deleteComment,
} from "./../../../services/commentnewsService";
import { deleteNews } from "./../../../services/newsServices";
import { useUser } from "./../../Home/UserContext";

const NewsCard = ({ news, onDelete, canModify, refreshList }) => {
  const { user } = useUser();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isNewsModalOpen, setIsNewsModalOpen] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [isCommentFormVisible, setIsCommentFormVisible] = useState(false);

  useEffect(() => {
    fetchComments();
  }, []);

  const fetchComments = async () => {
    try {
      const fetchedComments = await getCommentsByNews(news.id);
      setComments(fetchedComments);
    } catch (error) {
      console.error("Erreur lors du chargement des commentaires:", error);
    }
  };

  // const handleAddComment = async () => {
  //   if (!user || !user.userId || !newComment) {
  //     console.error("Erreur: utilisateur non identifié ou commentaire vide.");
  //     return;
  //   }

  //   const commentData = {
  //     content: newComment,
  //     user_id: user.userId,
  //     news_id: news.id,
  //   };

  //   try {
  //     await createComment(commentData);
  //     setNewComment("");
  //     setIsCommentFormVisible(false);
  //     fetchComments();
  //   } catch (error) {
  //     console.error("Erreur lors de la création du commentaire:", error);
  //   }
  // };

  // const handleDeleteComment = async (commentId) => {
  //   try {
  //     await deleteComment(commentId);
  //     fetchComments();
  //   } catch (error) {
  //     console.error("Erreur lors de la suppression du commentaire:", error);
  //   }
  // };

  const handleEdit = () => setIsEditModalOpen(true);
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    refreshList();
  };

  const handleDeleteNews = async () => {
    try {
      await deleteNews(news.id);
      refreshList();
    } catch (error) {
      console.error("Erreur lors de la suppression de l'actualité:", error);
    }
  };

  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    setIsImageModalOpen(false);
  };

  const openNewsModal = () => {
    setIsNewsModalOpen(true);
  };

  const closeNewsModal = () => {
    setIsNewsModalOpen(false);
  };

  return (
    <>
      <div className="flex flex-col md:flex-row bg-white dark:bg-gray-700 bg-opacity-80 rounded-lg overflow-hidden shadow-md relative m-4">
        <img
          src={news.image_url || "/img/no-image.jpg"}
          alt={news.title || "Image non disponible"}
          className="md:w-1/2 object-cover rounded-t-lg md:rounded-tr-none md:rounded-l-lg max-h-72 w-full h-full cursor-pointer"
          onClick={() => openImageModal(news.image_url || "/img/no-image.jpg")}
        />
        <div className="p-4 flex flex-col justify-between">
          <div>
            <h3 className="text-lg font-bold uppercase text-gray-800 my-2 w-full font-satoshi">
              {news.title}
            </h3>
            <h5 className="text-xs mb-3 text-black bg-gray-200 p-2">
              {news.author?.prenom} {news.author?.nom}
            </h5>

            {/* Texte tronqué à 5-6 lignes */}
            <div className="text-gray-600 text-justify w-full mb-4 line-clamp-6">
              <div dangerouslySetInnerHTML={{ __html: news.content }} />
            </div>

            {/* Bouton "Suite ..." */}
            <button
              onClick={openNewsModal}
              className="text-blue-500 hover:underline text-sm font-semibold"
            >
              Suite ...
            </button>
          </div>
          <div className="flex flex-row justify-between mt-4">
            <div className="flex gap-2">
              {canModify && (
                <>
                  <button
                    onClick={handleEdit}
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                  >
                    <FaEdit />
                  </button>
                  <button
                    onClick={handleDeleteNews}
                    className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                  >
                    <FaTrashAlt />
                  </button>
                </>
              )}
              {/* <button
                onClick={() => setIsCommentFormVisible(!isCommentFormVisible)}
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
              >
                <FaComment />
              </button> */}
            </div>
          </div>
        </div>
      </div>

      {/* Modale d'édition */}
      <EditNewsModal
        isOpen={isEditModalOpen}
        onClose={closeEditModal}
        refreshList={refreshList}
        news={news}
      />

      {/* Modale pour afficher l'article complet */}
      {isNewsModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-700 rounded-lg shadow-lg max-w-4xl w-full flex overflow-hidden">
            <div className="w-1/3">
              <img
                src={news.image_url || "/img/no-image.jpg"}
                alt="Agrandissement"
                className="w-full h-full object-cover rounded-l-lg"
              />
            </div>
            <div className="w-2/3 flex flex-col p-6 relative">
              <h2 className="text-xl font-bold mb-2">{news.title}</h2>
              <h5 className="text-xs mb-3 text-black bg-gray-200 p-2">
                {news.author?.prenom} {news.author?.nom}
              </h5>
              <div className="overflow-y-auto max-h-80 pr-2">
                <div
                  className="text-sm text-gray-700 dark:text-gray-300"
                  dangerouslySetInnerHTML={{ __html: news.content }}
                />
              </div>
              <button
                className="absolute top-2 right-2 text-gray-600 dark:text-gray-300 text-2xl"
                onClick={closeNewsModal}
                aria-label="Fermer"
              >
                &times;
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modale pour agrandir l'image seule */}
      {isImageModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
          onClick={closeImageModal}
        >
          <div className="relative">
            <img
              src={selectedImage}
              alt="Agrandissement"
              className="max-w-full max-h-[70vh] rounded-lg"
            />
            <button
              className="absolute top-2 right-2 text-white text-2xl"
              onClick={closeImageModal}
              aria-label="Fermer"
            >
              &times;
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default NewsCard;
